import { TFunction } from 'i18next'

export default (t: TFunction) => ({
  dataSetName: t('calculations'),
  dataName: t('calculation'),
  head: [
    {
      label: t('systemName'),
      key: 'systemDescription',
      col: 6,
      leftAlign: true,
      linkTo: '/calculations',
    },
    {
      label: t('amount'),
      key: 'amount',
      col: 2,
    },
    {
      label: t('unitPrice'),
      key: 'unitPrice',
      unit: 'EUR',
      col: 2,
    },
    {
      label: t('grossTotal'),
      key: 'totalPrice',
      unit: 'EUR',
      col: 2,
    },
  ],
})
